import {OrionApolloClient} from '@orion-js/graphql-client'
import getClients from '@providers/apollo/getClients'

export default function getClient(clientName: string = 'main'): OrionApolloClient<any> {
  const clients = getClients()
  return clients[clientName]
}
